import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import Container from "react-bootstrap/Container";
import { ErrorFallback } from "./ErrorFallback";
import SourceLinks from "./SourceLinks";
import Weather from "./Weather";
import { WeatherDataProvider } from "../context/WeatherDataContext";
import { DefaultCityProvider } from "../context/DefaultCityContext";
import DEFAULT_CITY from "../constants/defaultCity";

import "../../css/App.css";

const App = () => (
  <div className="App">
    <Container>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <DefaultCityProvider city={DEFAULT_CITY}>
          <WeatherDataProvider>
            <Weather />
          </WeatherDataProvider>
        </DefaultCityProvider>
      </ErrorBoundary>
      <SourceLinks />
    </Container>
  </div>
);

export default App;
